"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimePlatform = exports.ServiceError = void 0;
/**
 * Represents an error as returned by our public API.
 *
 * @property code The unique error code.
 * @property details The human-readable error message.
 * @property field The optional field subject of the error.
 * @property value The optional field value that triggered the error.
 */
class ServiceError {
    code;
    details;
    field;
    value;
    constructor(code, details, field, value) {
        this.code = code;
        this.details = details;
        this.field = field;
        this.value = value;
        this.code = code;
        this.details = details;
        this.field = field;
        this.value = value;
    }
}
exports.ServiceError = ServiceError;
/**
 * Represents the type of scope applicable to a policy.
 */
var RuntimePlatform;
(function (RuntimePlatform) {
    // Represents the iOS platform
    RuntimePlatform[RuntimePlatform["IOS"] = 0] = "IOS";
    // Represents the Android platform
    RuntimePlatform[RuntimePlatform["ANDROID"] = 1] = "ANDROID";
    // Represents a browser-based platform
    RuntimePlatform[RuntimePlatform["WEB"] = 2] = "WEB";
})(RuntimePlatform = exports.RuntimePlatform || (exports.RuntimePlatform = {}));
